import dialog from './dialog.html';

export default {
  title: 'Dialog',
  author: 'tianyanrong',
  html: [dialog],
  isCode: true,
};
